// extracted by mini-css-extract-plugin
module.exports = {"ticker":"Ticker_ticker__LgnEq","track":"Ticker_track__U3XEG"};